import orderTranslationsHelper from "../../../../languages/order-translations.helper";

const getContentMessageText = (cargoCompanyOrderId: number) => {
  const translations =
    orderTranslationsHelper.getDetailsTranslations().cancelOrderRequest
      .confirmationModal;

  return translations.contentMessageTemplateText.replace(
    "#{cargoCompanyOrderId}",
    String(cargoCompanyOrderId)
  );
};

const getRevertContentMessageText = (cargoCompanyOrderId: number) => {
  const translations =
    orderTranslationsHelper.getDetailsTranslations().revertCancelOrderRequest
      .confirmationModal;

  return translations.contentMessageTemplateText.replace(
    "#{cargoCompanyOrderId}",
    String(cargoCompanyOrderId)
  );
};

const orderDetailsOrderCancelRequestConfirmationHelper = {
  getContentMessageText,
  getRevertContentMessageText,
};

export default orderDetailsOrderCancelRequestConfirmationHelper;
